export const getEndpoints = environment => {
  switch (environment) {
    case 'PRODUCTION':
      return {
        GROUP_HUB_API: 'https://www.datacamp.com/groups'
      };
    case 'LOCAL':
    case 'TEST':
    case 'DEVELOPMENT':
    default:
      return {
        GROUP_HUB_API: 'https://www.datacamp-staging.com/groups'
      };
  }
};